import { struct } from 'io-ts/Decoder';

import { Type as UISettings } from '../../../../user/preferences/ui-settings/Type';

export const Request = struct({
	value: UISettings,
});
